<template>
  <div class="layout" :class="layoutClass">
      <slot></slot>
  </div>
</template>

<script>
export default {
    name: 'g-layout',
    data() {
        return {
            layoutClass: {
                hasSider: false
            }
        }
    },
    mounted() {
        this.$children.forEach(item => {
            if('g-aside' === item.$options.name) {
                this.layoutClass.hasSider = true
            }
        })
    }
}
</script>

<style lang="scss" scoped>
    .layout{
        flex-grow: 1;
        display:flex;
        flex-direction: column;
        &.hasSider{
            flex-direction: row;
        }
    }
</style>